import { For } from "solid-js";

/**
 * The wizard's error box. Server errors and client-side card errors land in the
 * same one, so there is one definition of what that looks like.
 */
export function Notice(props: { messages: string[] }) {
  return (
    <div class="rounded-lg bg-brand-danger-light px-4 py-3">
      <For each={props.messages}>
        {(message) => <p class="text-sm text-brand-danger">{message}</p>}
      </For>
    </div>
  );
}
